import { render, staticRenderFns } from "./referenceeditmodal.vue.html?vue&type=template&id=65d8e694"
import script from "./referenceeditmodal.controller?vue&type=script&lang=js&external"
export * from "./referenceeditmodal.controller?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports